import { Card, CardContent, Typography } from "@mui/material";
import { ReactNode } from "react";

interface MetricCardProps {
  label: string;
  children: ReactNode;
}

const MetricCard = ({ label, children }: MetricCardProps) => {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography
          variant="caption"
          color="secondary"
          display="block"
          sx={{ minHeight: "5em" }}
        >
          {label}
        </Typography>

        <Typography variant="h5" fontWeight={500}>
          {children}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
